import { Component, OnInit, SimpleChanges } from '@angular/core';
import { AgentService } from 'src/app/agent/services/agent.service';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { Router } from '@angular/router';
import { HeaderService } from 'src/app/system-common/services/header.service';
import { BaseSearchComponent } from 'src/app/system-common/base-search/base-search.component';
import { BreadCrumb } from 'src/app/models/common/bread-crumb';
import { PageHeader } from 'src/app/models/common/page-header';

@Component({
  selector: '',
  template: '',
})
export class TraningsAndExamsHandlerComponent extends BaseSearchComponent<AgentService> implements OnInit {
  public searchName: string;
  public isAdvanceSearchRequired: boolean;
  constructor(
    public service: AgentService,
    public headerService: HeaderService,
    public router: Router,
    public settingService: SettingService
  ) {
    super(service, router);
    this.isAdvanceSearchRequired = false;
    this.searchName = 'SearchUpcomingTrainingandExams';
  }

  ngOnInit() {
    super.ngOnInit();
  }

  ngOnChanges(changes: SimpleChanges) {
    super.ngOnChanges(changes);
  }

  protected getBreadCrumbList(): BreadCrumb[] {
    return [
      {
        id: 'Home',
        link: '/home',
      },
      {
        id: 'Search',
      },
    ];
  }

  protected getPageHeader(): PageHeader {
    let header = new PageHeader();
    header.title = this.settingService.getLabelValue('upcomingTrainingAndExams');
    return header;
  }
}
